// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';
import SearchAddressForm from '../../common/SearchAddressForm';

export default class FormView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.simple_form');
    this.searchAddress = new SearchAddressForm('.simple_form');

    this.render();
  }

  @on({
    event: 'change',
    selector:
      'input[name="officer_approval_director_meeting[is_pdf_document]"]',
  })
  onChangeIsPdfDocument() {
    this.render();
  }

  showPdfForm() {
    const isPdfDocument = $(
      'input[name="officer_approval_director_meeting[is_pdf_document]"]',
    )
      .filter(':checked')
      .val();
    if (isPdfDocument == 'true') {
      $('.pdf_document_form').show();
    } else {
      $('.pdf_document_form').hide();
    }
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        startDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD HH:mm',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD HH:mm',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  render() {
    this.showPdfForm();
    this.initDateRangePicker(this.$el);
  }
}
